module.exports = __webpack_public_path__ + "img/skill_bg.003f72a9.png";